import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bed4bcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card yield-trend-card" }
const _hoisted_2 = { class: "card-header flex-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "收益走势", -1))
const _hoisted_4 = { class: "time-filters" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "legend-area" }
const _hoisted_7 = { class: "legend-item strategy-legend" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 策略收益(模拟)")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line gray-line" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "no-data-container"
}

import { ref, onMounted, onUnmounted, watch, nextTick, computed } from 'vue'
import { useRoute } from 'vue-router'
import { DownOutlined } from '@ant-design/icons-vue'
import * as echarts from 'echarts'
import moment from 'moment'
import { useStarTheme } from '@/utils/useStarTheme'
import { fetchStrategyReturnDetail } from '@/api/starresultApi'
import store from '@/store/index'
import StarNoData from '@/components/star/StarNoData.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'YieldTrend',
  props: {
    isDark: { type: Boolean },
    isFactor: { type: Boolean },
    isAi: { type: Boolean },
    activeTab: null,
    isSubscribed: { type: Boolean },
    strategyColor: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  isDark: boolean
  isFactor: boolean
  isAi?: boolean
  activeTab?: string
  isSubscribed?: boolean
  strategyColor?: string
}

_useCssVars(_ctx => ({
  "3af938cf": (_unref(isDarkTheme) ? "rgba(102,102,102,1)" : "rgba(102,102,102,1)"),
  "03d60f31": (_unref(isDarkTheme) ? "rgba(37,37,37,1)" : "rgba(240,240,240,1)"),
  "3eea4222": (strategyLineColor.value)
}))



const route = useRoute()
const { colors } = useStarTheme()
const isDarkTheme = computed(() => props.isDark)
const strategyLineColor = ref(props.strategyColor || '#ff5c5c')

const chartRef = ref<HTMLElement | null>(null)
let chartInstance: echarts.ECharts | null = null
const hasData = ref(false)

const timeOptions = [
  { label: '近1月', value: 'month1' },
  { label: '近3月', value: 'month3' },
  { label: '近6月', value: 'month6' },
  { label: '近1年', value: 'year1' },
  { label: '全部', value: 'all' }
]
const currentTime = ref('all')
const currentBenchmark = ref('沪深300')
const chartData = ref<any>({ strategy: [], benchmark: [], aiReturns: [], subscribed: [] })

const menuItemList = ref([
  { key: '沪深300', value: '沪深300', baseMarket: 'sh', baseSymbol: '000300' }, // 正确
  { key: '上证指数', value: '上证指数', baseMarket: 'sh', baseSymbol: '000001' }, // 正确
  { key: '深证成指', value: '深证成指', baseMarket: 'sz', baseSymbol: '399001' }, // 正确
  { key: '创业板指', value: '创业板指', baseMarket: 'sz', baseSymbol: '399006' }, // ✅ 修正：原 399006 错误
  { key: '上证50', value: '上证50', baseMarket: 'sh', baseSymbol: '000016' },     // ✅ 修正：原 000905 错误
  { key: '中证500', value: '中证500', baseMarket: 'sh', baseSymbol: '000905' }   // ✅ 修正：原 000016 错误
]);

const currentBenchmarkLabel = ref('沪深300')

const handleBenchmarkChange = ({ key }: any) => {
  currentBenchmark.value = key
  const selected = menuItemList.value.find(item => item.key === key)
  if (selected) {
    currentBenchmarkLabel.value = selected.value
  }
  fetchData()
}

const changeTime = (t: string) => {
  currentTime.value = t
  fetchData()
}

const fetchData = async () => {
  const taskID = (route.query.taskID as string) || (route.params.taskID as string)
  const selectedBenchmark = menuItemList.value.find(item => item.key === currentBenchmark.value) || menuItemList.value[1]
  const token = (route.query.token as string) || (route.params.token as string)
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'

  try {
    const res: any = await fetchStrategyReturnDetail({
      data: {
        taskID,
        baseMarket: selectedBenchmark.baseMarket,
        baseSymbol: selectedBenchmark.baseSymbol,
        period: currentTime.value
      },
      headers: {
        token,
        username
      }
    })

    if (res && res.data) {
      const { returns, aiReturns } = res.data

      const strategy: any[] = []
      const benchmark: any[] = []
      const aiData: any = { v1: [], v2: [], v3: [], b: [] }
      const subscribedDates = new Set<string>()

      if (returns && returns.length > 0) {
        returns.forEach((item: any) => {
          const dateStr = moment(item.d).format('YYYY-MM-DD')
          strategy.push({ date: dateStr, value: item.v * 100 })
          benchmark.push({ date: dateStr, value: item.b * 100 })
          // a 字段存在且包含 1 代表订阅点
          if (Array.isArray(item.a) && item.a.includes(1)) {
            subscribedDates.add(dateStr)
          }
        })
      }

      if (aiReturns && aiReturns.length > 0) {
        aiReturns.forEach((item: any) => {
          const dateStr = moment(item.d).format('YYYY-MM-DD')
          aiData.v1.push({ date: dateStr, value: item.v1 * 100 })
          aiData.v2.push({ date: dateStr, value: item.v2 * 100 })
          aiData.v3.push({ date: dateStr, value: item.v3 * 100 })
          aiData.b.push({ date: dateStr, value: item.b * 100 })
        })
      }

      chartData.value = { strategy, benchmark, aiReturns: aiData, subscribedDates: Array.from(subscribedDates) }
      const aiHasData = aiData.v1.length > 0 || aiData.v2.length > 0 || aiData.v3.length > 0
      const newHasData = props.isAi ? aiHasData : strategy.length > 0

      if (newHasData) {
        hasData.value = true
        await nextTick()
        renderChart()
        if (chartRef.value && !resizeObserver) {
          resizeObserver = new ResizeObserver(() => {
            if (chartInstance) chartInstance.resize()
          })
          resizeObserver.observe(chartRef.value)
        }
      } else {
        hasData.value = false
      }
    }
  } catch (error) {
    console.error('Failed to fetch return detail:', error)
  }
}

const renderChart = () => {
  if (!chartRef.value) return
  if (!chartInstance) {
    chartInstance = echarts.init(chartRef.value)
  } else {
    chartInstance.clear()
  }

  // AI 模式下从 aiReturns 取 dates 和 benchmark（b 字段）
  const isAiMode = props.isAi && props.activeTab
  const aiArr = isAiMode ? (chartData.value.aiReturns[
    props.activeTab === 'best-yield' ? 'v1' : props.activeTab === 'best-winrate' ? 'v2' : 'v3'
  ] || []) : []

  const dates = isAiMode
    ? aiArr.map((item: any) => item.date)
    : chartData.value.strategy.map((item: any) => item.date)
  const strategyValues = chartData.value.strategy.map((item: any) => item.value)
  const benchmarkValues = isAiMode
    ? chartData.value.aiReturns.b?.map((item: any) => item.value) || []
    : chartData.value.benchmark.map((item: any) => item.value)

  // 订阅点日期集合
  const subscribedDatesSet = new Set(chartData.value.subscribedDates || [])

  // 为订阅点生成 scatter 数据（用日期字符串作为 x 轴坐标）
  const subscribedScatterData: any[] = []
  dates.forEach((date: string, index: number) => {
    if (subscribedDatesSet.has(date)) {
      subscribedScatterData.push([date, strategyValues[index] ?? 0])
    }
  })

  // AI 模式：根据 activeTab 只显示对应曲线，非 AI 模式显示 strategy + benchmark
  const AI_TAB_SERIES_MAP: Record<string, { key: 'v1' | 'v2' | 'v3'; name: string; color: string }> = {
    'best-yield': { key: 'v1', name: '收益优先', color: '#f5222d' },
    'best-winrate': { key: 'v2', name: '胜率优先', color: '#1890ff' },
    'best-ratio': { key: 'v3', name: '盈亏比优先', color: '#722ed1' },
  }

  const series: any[] = []

  if (props.isAi && props.activeTab && chartData.value.aiReturns) {
    const conf = AI_TAB_SERIES_MAP[props.activeTab]
    const aiArr = chartData.value.aiReturns[conf.key] || []
    // 同步 legend 颜色
    strategyLineColor.value = conf.color
    // AI 曲线
    series.push({
      name: conf.name,
      type: 'line',
      data: aiArr.map((item: any) => item.value),
      itemStyle: { color: conf.color },
      lineStyle: { width: 2, color: conf.color },
      showSymbol: false,
      smooth: true
    })
    // 基准线
    series.push({
      name: currentBenchmarkLabel.value,
      type: 'line',
      data: benchmarkValues,
      itemStyle: { color: '#888888' },
      lineStyle: { width: 2, color: '#888888' },
      showSymbol: false,
      smooth: true
    })
  } else {
    const lineColor = props.strategyColor || '#ff5c5c'
    // 同步 legend 颜色
    strategyLineColor.value = lineColor
    series.push({
      name: '策略收益(模拟)',
      type: 'line',
      data: strategyValues,
      itemStyle: { color: lineColor },
      lineStyle: { width: 2, color: lineColor },
      showSymbol: false,
      smooth: true
    })
    series.push({
      name: currentBenchmarkLabel.value,
      type: 'line',
      data: benchmarkValues,
      itemStyle: { color: '#888888' },
      lineStyle: { width: 2, color: '#888888' },
      showSymbol: false,
      smooth: true
    })
  }

  // 订阅点 scatter 系列（叠加在曲线上方）
  if (subscribedScatterData.length > 0) {
    series.push({
      name: '__subscribed__',
      type: 'scatter',
      data: subscribedScatterData,
      symbol: 'circle',
      symbolSize: 10,
      itemStyle: {
        color: '#FFB626',
        borderColor: '#fff',
        borderWidth: 1.5
      },
      z: 10,
      tooltip: { show: false }
    })
  }

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: colors.value.textSecondary
        }
      },
      formatter: (params: any) => {
        let res = `${params[0].name}<br/>`
        params.forEach((p: any) => {
          if (p.seriesName === '__subscribed__') return
          const val = p.value
          const color = val > 0 ? '#cc2b1d' : val < 0 ? '#439731' : 'inherit'
          const valStr = (val < 0 ? '-' : '') + Math.abs(val).toFixed(10).replace(/^(\d+\.\d{2})\d*$/, '$1')
          res += `${p.marker} ${p.seriesName}: <span style="color:${color}">${valStr}%</span><br/>`
        })
        // 判断当前 hover 的日期是否是订阅点
        const hoverDate = params[0]?.name
        if (hoverDate && subscribedDatesSet.has(hoverDate)) {
          res += `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#FFB626;margin-right:4px;"></span> <span style="color:#FFB626">订阅</span><br/>`
        }
        return res
      }
    },
    legend: {
      show: false,
      top: 0,
      right: 10,
      textStyle: { color: colors.value.textSecondary }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: dates,
      axisLine: { lineStyle: { color: colors.value.border } },
      axisLabel: { color: colors.value.textSecondary }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: colors.value.divider } },
      axisLabel: { color: colors.value.textSecondary }
    },
    series
  }

  chartInstance.setOption(option, { replaceMerge: ['series'] })
}

watch(() => colors.value.bg, () => {
  if (chartInstance) {
    renderChart()
  }
})

watch(() => props.strategyColor, () => {
  if (chartInstance && hasData.value) {
    renderChart()
  }
})

watch(() => props.activeTab, () => {
  if (chartInstance && hasData.value) {
    renderChart()
  }
})

watch(() => route.query.taskID, (newVal, oldVal) => {
  if (route.query.isocbt === '1') return
  if (newVal && newVal !== oldVal) {
    fetchData()
  }
})

let resizeObserver: ResizeObserver | null = null

const handleResize = () => {
  if (chartInstance) {
    chartInstance.resize()
  }
}

onMounted(() => {
 
    fetchData()
 
  window.addEventListener('resize', handleResize)
  if (chartRef.value) {
    resizeObserver = new ResizeObserver(() => {
      if (chartInstance) chartInstance.resize()
    })
    resizeObserver.observe(chartRef.value)
  }
})

expose({ reload: fetchData })


onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  if (resizeObserver) resizeObserver.disconnect()
  if (chartInstance) {
    chartInstance.dispose()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOptions, (t) => {
          return _createElementVNode("span", {
            key: t.value,
            class: _normalizeClass(['time-btn', { active: currentTime.value === t.value }]),
            onClick: ($event: any) => (changeTime(t.value))
          }, _toDisplayString(t.label), 11, _hoisted_5)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("span", {
            class: "line",
            style: _normalizeStyle({ backgroundColor: strategyLineColor.value })
          }, null, 4),
          _hoisted_8
        ]),
        _createVNode(_component_a_dropdown, null, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, { onClick: handleBenchmarkChange }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItemList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "ant-dropdown-link legend-item benchmark-legend",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(currentBenchmarkLabel.value) + " ", 1),
              _createVNode(_unref(DownOutlined))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    (hasData.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "chart-container",
          ref_key: "chartRef",
          ref: chartRef
        }, null, 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(StarNoData, { isDark: __props.isDark }, null, 8, ["isDark"])
        ]))
  ]))
}
}

})